import React, { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faTasks, faTachometer, faPlus, faArrowLeft, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { EQUIPMENT_OPTIONS } from "../../Constants/FieldOptions";

import { postSessionTemplateCreateAPI } from "../../API/SessionTemplate";
import FormErrorBox from "../Reusable/FormErrorBox";
import FormInputField from "../Reusable/FormInputField";
import FormTextareaField from "../Reusable/FormTextareaField";
import FormMultiSelectField from "../Reusable/FormMultiSelectField";
import FormRadioField from "../Reusable/FormRadioField";
import FormCheckboxField from "../Reusable/FormCheckboxField";
import { useRecoilState } from 'recoil';

import { topAlertMessageState, topAlertStatusState } from "../../AppState";



function SessionTemplateAdd() {
    ////
    ////
    ////

    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [isFetching, setFetching] = useState(false);
    const [forceURL, setForceURL] = useState("");
    const [created, setCreated] = useState();
    const [userID, setUserID] = useState();
    const [no, setNo] = useState();
    const [completedTime, setCompletedTime] = useState();
    const [duration, setDuration] = useState();
    const [totalDuration, setTotalDuration] = useState();
    const [name, setName] = useState();
    const [description, setDescription] = useState();
    const [brief, setBrief] = useState();
    const [equipment, setEquipment] = useState([]);
    const [isPrimarySession, setIsPrimarySession] = useState(false);
    const [targetHeartRateRatio, setTargetHeartRateRatio] = useState();
    const [sessionType, setSessionType] = useState();

    ////
    //// Event handling.
    ////

    const onEquipmentChange = (e) => {
        console.log("onEquipmentChange, e:",e);
        let values = [];
        for (let option of e) {
            console.log("option:",option);
            values.push(option.value);
        }
        console.log("onEquipmentChange, values:",values);
        setEquipment(values);
    }

    const onSubmitClick = (e) => {
        console.log("onSubmitClick: Beginning...");
        const sessionTemplate = {
            created: parseInt(created),
            userID: userID,
            no: parseInt(no),
            completedTime: completedTime,
            duration: duration,
            totalDuration: totalDuration,
            name: name,
            description: description,
            brief: brief,
            equipment: equipment,
            isPrimarySession: isPrimarySession,
            targetHeartRateRatio: targetHeartRateRatio,
            sessionType: sessionType,
        };
        console.log("onSubmitClick, sessionTemplate:", sessionTemplate);
        postSessionTemplateCreateAPI(sessionTemplate, onSessionTemplateCreateSuccess, onSessionTemplateCreateError, onSessionTemplateCreateDone);
    }

    ////
    //// API.
    ////

    function onSessionTemplateCreateSuccess(response){
        // For debugging purposes only.
        console.log("onSessionTemplateCreateSuccess: Starting...");
        console.log(response);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("SessionTemplate created");
        setTopAlertStatus("success");
        setTimeout(() => {
            console.log("onSessionTemplateCreateSuccess: Delayed for 2 seconds.");
            console.log("onSessionTemplateCreateSuccess: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Redirect the user to a new page.
        setForceURL("/session-template/"+response.id);
    }

    function onSessionTemplateCreateError(apiErr) {
        console.log("onSessionTemplateCreateError: Starting...");
        setErrors(apiErr);

        // Add a temporary banner message in the app and then clear itself after 2 seconds.
        setTopAlertMessage("Failed submitting");
        setTopAlertStatus("danger");
        setTimeout(() => {
            console.log("onSessionTemplateCreateError: Delayed for 2 seconds.");
            console.log("onSessionTemplateCreateError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateCreateDone() {
        console.log("onSessionTemplateCreateDone: Starting...");
        setFetching(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
        }

        return () => { mounted = false; }
    }, []);

    ////
    //// Component rendering.
    ////

    if (forceURL !== "") {
        return <Navigate to={forceURL}  />
    }

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/session-templates" aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Templates</Link></li>
                            <li class="is-active"><Link aria-current="page"><FontAwesomeIcon className="fas" icon={faPlus} />&nbsp;New</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to="/session-templates" aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Session Templates</Link></li>
                        </ul>
                    </nav>

                    {/* Page content */}
                    <nav class="box">
                        <article class="message is-danger">
                          <div class="message-body">
                            <FontAwesomeIcon className="mdi" icon={faExclamationTriangle} />&nbsp;This functionality is only for testing purposes.
                          </div>
                        </article>

                        <p class="title is-4"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Template</p>
                        <FormErrorBox errors={errors} />

                        <p class="subtitle is-6">Details</p>

                        {isFetching && <div class="columns is-centered" style={{paddingTop: "20px"}}>
                            <div class="column has-text-centered is-2">
                            <div class="loader-wrapper is-centered">
                              <div class="loader is-loading is-centered" style={{height: "80px", width: "80px"}}></div>
                            </div>
                            </div>
                        </div>}

                        {!isFetching && <div class="container">
                            <FormInputField
                                label="Created"
                                name="created"
                                type="number"
                                placeholder="0 or 1"
                                value={created}
                                errorText={errors && errors.created}
                                helpText="Note: Controlled by system"
                                onChange={(e)=>setCreated(parseInt(e.target.value))}
                                isRequired={true}
                                maxWidth="85px"
                            />

                            <FormInputField
                                label="User ID (Optional)"
                                name="userID"
                                type="text"
                                placeholder="Text input"
                                value={userID}
                                errorText={errors && errors.userID}
                                helpText="Note: Controlled by system"
                                onChange={(e)=>setUserID(e.target.value)}
                                isRequired={true}
                                maxWidth="75px"
                            />

                            <FormInputField
                                label="No"
                                name="no"
                                type="number"
                                placeholder="#"
                                value={no}
                                errorText={errors && errors.no}
                                helpText="Note: Controlled by system"
                                onChange={(e)=>setNo(parseInt(e.target.value))}
                                isRequired={true}
                                maxWidth="75px"
                            />

                            <FormInputField
                                label="Completed Time (Optional)"
                                name="completedTime"
                                placeholder="Text input"
                                value={completedTime}
                                errorText={errors && errors.completedTime}
                                helpText="Note: Controlled by system"
                                onChange={(e)=>setCompletedTime(e.target.value)}
                                isRequired={true}
                                maxWidth="350px"
                            />

                            <FormInputField
                                label="Duration (Duration)"
                                name="duration"
                                type="number"
                                placeholder="#"
                                value={duration}
                                errorText={errors && errors.duration}
                                helpText="Measured in minutes"
                                onChange={(e)=>setDuration(parseInt(e.target.value))}
                                isRequired={true}
                                maxWidth="100px"
                            />

                            <FormInputField
                                label="Total Duration (Optional)"
                                name="totalDuration"
                                type="number"
                                placeholder="#"
                                value={totalDuration}
                                errorText={errors && errors.totalDuration}
                                helpText="Note: Controlled by system"
                                onChange={(e)=>setTotalDuration(parseInt(e.target.value))}
                                isRequired={true}
                                maxWidth="100px"
                            />

                            <FormInputField
                                label="Name"
                                name="name"
                                placeholder="Text input"
                                value={name}
                                errorText={errors && errors.name}
                                helpText=""
                                onChange={(e)=>setName(e.target.value)}
                                isRequired={true}
                                maxWidth="350px"
                            />

                            <FormTextareaField
                                label="Description (Optional)"
                                name="description"
                                placeholder="Text input"
                                value={description}
                                errorText={errors && errors.description}
                                helpText=""
                                onChange={(e)=>setDescription(e.target.value)}
                                isRequired={true}
                                maxWidth="100%"
                                rows={4}
                            />

                            <FormTextareaField
                                label="Brief (Optional)"
                                name="brief"
                                placeholder="Text input"
                                value={brief}
                                errorText={errors && errors.brief}
                                helpText=""
                                onChange={(e)=>setBrief(e.target.value)}
                                isRequired={true}
                                maxWidth="100%"
                                rows={2}
                            />

                            <FormMultiSelectField
                                label="Equipment (Optional)"
                                name="equipment"
                                placeholder="Text input"
                                options={EQUIPMENT_OPTIONS}
                                selectedValues={equipment}
                                onChange={onEquipmentChange}
                                errorText={errors && errors.equipment}
                                helpText="Pick the equipment associated with this session template."
                                isRequired={true}
                                maxWidth="320px"
                            />

                            <FormInputField
                                label="Target Heart Rate Ratio (Optional)"
                                name="targetHeartRateRatio"
                                type="number"
                                placeholder="#"
                                value={targetHeartRateRatio}
                                errorText={errors && errors.targetHeartRateRatio}
                                helpText=""
                                onChange={(e)=>setTargetHeartRateRatio(parseInt(e.target.value))}
                                isRequired={true}
                                maxWidth="75px"
                            />

                            <FormRadioField
                                label="Session Type"
                                name="sessionType"
                                value={sessionType}
                                opt1Value="base"
                                opt1Label="Base"
                                opt2Value="breath"
                                opt2Label="Breath"
                                opt3Value="sleep"
                                opt3Label="Sleep"
                                errorText={errors && errors.sessionType}
                                onChange={(e)=>setSessionType(e.target.value)}
                                maxWidth="180px"
                            />

                            <FormCheckboxField
                                label="Is primary session?"
                                name="isPrimarySession"
                                value={isPrimarySession}
                                opt1Value={true}
                                opt1Label="Yes"
                                opt2Value={false}
                                opt2Label="No"
                                errorText={errors && errors.isPrimarySession}
                                wasValidated={false}
                                helpText=""
                                onChange={(e)=>setIsPrimarySession(!isPrimarySession)}
                            />

                            <div class="columns">
                                <div class="column is-half">
                                    <Link to={`/session-templates`} class="button is-hidden-touch"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                    <Link to={`/session-templates`} class="button is-fullwidth is-hidden-desktop"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back</Link>
                                </div>
                                <div class="column is-half has-text-right">
                                    <button class="button is-primary is-hidden-touch" onClick={onSubmitClick}><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                    <button class="button is-primary is-fullwidth is-hidden-desktop" onClick={onSubmitClick}><FontAwesomeIcon className="fas" icon={faCheckCircle} />&nbsp;Save</button>
                                </div>
                            </div>

                        </div>}
                    </nav>
                </section>
            </div>
        </>
    );
}

export default SessionTemplateAdd;
